"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quizClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var quizClick = function (event) {
    var eventData = {
        event: analytics_layer_1.LinkInteractionEventNames.QuizClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.QuizClick,
        quizInfo: {
            'quizFilter': event.eventData.quizInfo.quizFilter || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.quizClick = quizClick;
